function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { Button, withStyles } from '@material-ui/core';
import { DeleteForever } from '@material-ui/icons'; // using withStyles allows us to customize the button's default style, but extend it with a className passed down to it without any funk prop stuff
// https://material-ui.com/components/buttons/#customized-buttons

const DeleteButton = withStyles(theme => ({
  root: {
    backgroundColor: theme.palette.error[500],
    color: theme.palette.getContrastText(theme.palette.error[500]),
    '&:hover': {
      backgroundColor: theme.palette.error[700]
    }
  }
}))(props => React.createElement(Button, _extends({
  variant: "contained",
  startIcon: React.createElement(DeleteForever, null)
}, props)));
DeleteButton.defaultProps = {
  children: 'Delete'
};
export default DeleteButton;